import React, { useMemo } from 'react'

import { Breadcrumbs, Typography } from '@mui/material'
import Link, { LinkProps } from '@mui/material/Link'

import { Link as RouterLink, match, matchPath, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export interface MappingProps {
  [key: string]: string | React.FunctionComponent | (({ uuid }: { uuid: string }) => string)
}

interface LinkRouterProps extends LinkProps {
  to: string
  replace?: boolean
}

interface BreadcrumbsPathProps {
  breadcrumbsMap: MappingProps
}

const LinkRouter = (props: LinkRouterProps) => <Link {...props} component={RouterLink as any} />

interface IBreadcrumbMapMatch {
  path: string
  text: string
  match: match
}

const BreadcrumbsPath: React.FC<BreadcrumbsPathProps> = ({ breadcrumbsMap }) => {
  const location = useLocation()
  const { t } = useTranslation()

  const routeMatches = useMemo<IBreadcrumbMapMatch[]>(() => {
    return Object.entries(breadcrumbsMap)
      .map(([key, value]) => ({
        path: key,
        text: value,
        match: matchPath(location.pathname, { path: key })
      }))
      .filter(m => !!m.match) as IBreadcrumbMapMatch[]
  }, [breadcrumbsMap, location])

  return (
    <Breadcrumbs aria-label='breadcrumb'>
      {routeMatches.map((m, index) => {
        const last = index === routeMatches.length - 1
        return last ? (
          <Typography color='textPrimary' key={m.match.url}>
            {t(m.text)}
          </Typography>
        ) : (
          <LinkRouter underline='none' to={m.match.url} key={m.match.url}>
            {t(m.text)}
          </LinkRouter>
        )
      })}
    </Breadcrumbs>
  )
}

export default BreadcrumbsPath
